import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, theme } from 'antd';
import AppHeader from './components/AppHeader';
import AppSidebar from './components/AppSidebar';
import Dashboard from './pages/Dashboard';
import MemberList from './pages/MemberList';
import MemberForm from './pages/MemberForm';
import QRCodePage from './pages/QRCodePage';
import Login from './pages/Login';

const { Content } = Layout;

function App() {
  const [user, setUser] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // 模拟登录
  const handleLogin = (userData) => {
    setUser(userData);
  };

  // 模拟登出
  const handleLogout = () => {
    setUser(null);
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={
          user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />
        } />
        <Route path="*" element={
          user ? (
            <Layout style={{ minHeight: '100vh' }}>
              <AppSidebar collapsed={collapsed} userRole={user?.role} />
              <Layout>
                <AppHeader 
                  collapsed={collapsed} 
                  setCollapsed={setCollapsed} 
                  user={user}
                  onLogout={handleLogout}
                />
                <Content
                  style={{
                    margin: '24px 16px',
                    padding: 24,
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <Routes>
                    <Route path="/" element={<Dashboard user={user} />} />
                    <Route path="/members" element={<MemberList user={user} />} />
                    <Route path="/members/add" element={<MemberForm user={user} />} />
                    <Route path="/members/edit/:id" element={<MemberForm user={user} />} />
                    <Route path="/qrcode" element={<QRCodePage user={user} />} />
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </Content>
              </Layout>
            </Layout>
          ) : (
            <Navigate to="/login" />
          )
        } />
      </Routes>
    </Router>
  );
}

export default App; 